import classnames from 'classnames';

export { classnames };

let currentId = 1;

export function getUniqueId() {
    return `id_${currentId++}`;
}
export function getInputValue(input) {
    if (!input) {
        return null;
    }

    // if (input.tagName.toLowerCase() === 'textarea') {
    //     return input.value;
    // }

    switch (input.type) {
        case 'checkbox':
        case 'radio':
            return input.checked;
        default:
            return input.value;
    }
}

export function toNullableNumber(s: string) {
    if (s === '') {
        return null;
    }

    return +s;
}

export function toOptionalNumber(s: string) {
    if (s === '') {
        return undefined;
    }

    return +s;
}

interface Font {
    weight: string;
    size: string;
    family: string;
}

const defaultFont: Font = {
    weight: '400',
    size: '14px',
    family: 'Roboto',
};

let cacheCanvas: HTMLCanvasElement | null = null;
export function measureTextWidth(text: string | number, font: Partial<Font> = defaultFont) {
    font = { ...defaultFont, ...font };

    if (!cacheCanvas) {
        cacheCanvas = document.createElement('canvas');
        var docFragment = document.createDocumentFragment();
        docFragment.appendChild(cacheCanvas);
    }
    const context = cacheCanvas!.getContext('2d')!;
    context.font = [font.weight, font.size, font.family].join(' ');

    return cacheCanvas!.getContext('2d')!.measureText(text.toString()).width;
}

export const focusableElementsSelector =
    'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), [tabindex="0"]';

export const scrollTo = (x: number, y: number) => {
    const supportsNativeSmoothScroll = 'scrollBehavior' in document.documentElement.style;
    if (supportsNativeSmoothScroll) {
        window.scrollTo({
            left: x,
            top: y,
            behavior: 'smooth',
        });
    } else {
        window.scrollTo(x, y);
    }
};

// export function getImageSize(image: HTMLImageElement) {
//     const { width, height } = image;

//     return {
//         width,
//         height,
//         aspectRatio: width / height,
//     };
// }

export function getOuterHeight(el: HTMLElement) {
    let height = el.clientHeight;

    const style = window.getComputedStyle(el);

    height += parseInt(style.borderTopWidth, 10);
    height += parseInt(style.borderBottomWidth, 10);
    height += parseInt(style.marginTop, 10);
    height += parseInt(style.marginBottom, 10);

    return height;
}
